import { FC } from 'react';
import { Button, Result } from 'antd';
import AppLayout from 'packages/lib/common-ui/app-shell/app-layout';

export const Error500Result: FC<React.PropsWithChildren<unknown>> = () => (
  <Result
    status="500"
    title="500"
    subTitle="Sorry, something went wrong."
    extra={
      <Button
        role="link"
        href={
          window.location.origin +
          (window.location.pathname.includes('contractor') ? '/contractor' : '')
        }
        type="primary"
      >
        Back Home
      </Button>
    }
  />
);

export const ErrorPage500: FC<React.PropsWithChildren<unknown>> = () => (
  <AppLayout>
    <Error500Result />
  </AppLayout>
);

export default ErrorPage500;
